import { GetProductsParams, inventoryProductService } from "../../../../../Api/Services/InventoryService/inventoryProduct";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { InventoryProductListResponse } from "../../types";



// Fetch products
export const fetchInventoryProducts = createServiceAsyncThunk<
    InventoryProductListResponse,
    GetProductsParams // params type
>(
    ACTION_NAMES.FETCH_INVENTORY_PRODUCT_LIST, 
    (params) => inventoryProductService.getProducts(params),
    ERROR_MESSAGES.FETCH_INVENTORY_PRODUCT_FAILURE 
);

export const inventoryProductSlice = createGenericSlice<
    InventoryProductListResponse,
    GetProductsParams
>(
    SLICE_NAMES.INVENTORY_PRODUCT_LIST_SLICE, 
    fetchInventoryProducts
);

export const {
    clearError: clearInventoryProductListError,
    clearSuccessMessage: clearInventoryProductListSuccessMessage,
} = inventoryProductSlice.actions;

export default inventoryProductSlice.reducer;